export default "__VITE_ASSET__C4uz1Kln__"